#import "../fragments/newsletter-fragment.graphql"

query GetNewsletter($newsletterId: ID!) {
    campaign(id: $newsletterId) {
        ...NewsletterFragment
    }
}
